import React from 'react';
import { Button, Modal } from 'react-bootstrap';

function DeleteConfirmModal(props) {
  return (
    <Modal {...props}>
      <Modal.Header closeButton>
        <Modal.Title>Delete Confirmation</Modal.Title>
      </Modal.Header>
      <Modal.Body>{'Are you sure you want to delete this target ?'}</Modal.Body>
      <Modal.Footer>
        <Button variant="secondary" onClick={props.onHide}>
          Close
        </Button>
        <Button type="submit" variant="danger" onClick={props.onDelete}>
          Delete
        </Button>
      </Modal.Footer>
    </Modal>
  );
}

export default DeleteConfirmModal;
